import config from '@/config';
import { EventType } from '@/types';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}
// const DEBUG = import.meta.env.DEV;

type PosthogLite = {
  identify: (id?: string) => void;
  reset: () => void;
  setPersonProperties: (props: Record<string, any>) => void;
  capture: (event: string, properties?: Record<string, any>) => void;
  captureException: (error: Error, properties?: Record<string, any>) => void;
} | null;

let posthogRef: PosthogLite = null;
let isPosthogReady = false;

type QueuedEvent = {
  type: EventType;
  args: Record<string, any>;
  error?: Error;
};

const queuedEvents: QueuedEvent[] = [];

function flushQueuedEvents() {
  if (!isPosthogReady || !posthogRef) {
    return;
  }

  while (queuedEvents.length > 0) {
    const { type, args, error } = queuedEvents.shift() as QueuedEvent;

    dispatchToPosthog(type, args, error);
  }
}

function dispatchToPosthog(
  type: EventType,
  args: Record<string, any>,
  error?: Error,
) {
  if (!posthogRef) {
    return;
  }

  switch (type) {
    case EventType.EXCEPTION_CAUGHT:
      if (error) {
        posthogRef.captureException(error, args);
      }
      break;
    case EventType.LOG_IN:
      posthogRef.identify(args.address);
      break;
    case EventType.LOG_OUT:
      posthogRef.reset();
      break;
    case EventType.ACCOUNT_REGISTERED:
      posthogRef.setPersonProperties({
        email: args.email,
        is_funded: args.isFunded,
      });
      break;
    default:
      posthogRef.capture(type, args);
      break;
  }
}

// Listen for PostHog readiness signaled by the app once the SDK is lazily initialized.
if (typeof window !== 'undefined') {
  window.addEventListener(
    'posthog:ready',
    ((event: Event) => {
      // CustomEvent with `detail` holds the PostHog instance
      const custom = event as CustomEvent<any>;
      posthogRef = custom.detail || (window as any).posthog || null;
      isPosthogReady = Boolean(posthogRef);
      flushQueuedEvents();
    }) as EventListener,
    { once: true },
  );
}

export function sendEvent(
  type: EventType,
  args: Record<string, any> = {},
  error?: Error,
) {
  if (config.isLocal || !config.isProduction) {
    return;
  }

  if (!isPosthogReady || !posthogRef) {
    queuedEvents.push({ type, args, error });
    return;
  }

  dispatchToPosthog(type, args, error);
}

// if ('gtag' in window) {
//   const { address } = useAccountStore.getState();
//   window.gtag('event', type, {
//     ...args,
//     address,
//     ...(debug ? { debug_mode: true } : {}),
//   });
// }
